import React, { useCallback } from 'react';

// eslint-disable-next-line custom-rules/no-react-router-dom-usenavigate
import { To, useNavigate as useReactNavigate } from 'react-router-dom';

export function useNavigate() {
    const navigate = useReactNavigate();

    const browserNavigate = useCallback(
        ({ event, to }: { event: React.MouseEvent; to: To }) => {
            if (event.defaultPrevented) return;
            if (event.button !== 0) return;
            if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) return;

            const target = event.currentTarget.getAttribute('target');
            if (target && target !== '_self') return;

            event.preventDefault();
            navigate(to);
        },
        [navigate],
    );

    return { browserNavigate, navigate };
}
